// extracted by mini-css-extract-plugin
module.exports = {"container":"H_x","containerSpaced":"H_bQ","buttonSize":"H_bR","feedbackContainer":"H_bS","policy":"H_bT","underline":"H_bV"};